import React from 'react';
import { Shirt, Calendar, Award, Check } from 'lucide-react';
export function TrialDetails() {
  return <div className="space-y-8" data-id="element-231">
      <div data-id="element-232">
        <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-233">
          What's Included
        </h3>
        <div className="space-y-6" data-id="element-234">
          <div className="flex" data-id="element-235">
            <div className="flex-shrink-0 mr-4" data-id="element-236">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-237">
                <Calendar className="w-5 h-5 text-primary" data-id="element-238" />
              </div>
            </div>
            <div data-id="element-239">
              <h4 className="text-lg font-semibold text-gray-900" data-id="element-240">
                4 Weeks of Classes
              </h4>
              <p className="text-gray-600" data-id="element-241">
                Unlimited access to age-appropriate classes for 4 consecutive
                weeks.
              </p>
            </div>
          </div>

          <div className="flex" data-id="element-242">
            <div className="flex-shrink-0 mr-4" data-id="element-243">
              <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center" data-id="element-244">
                <Shirt className="w-5 h-5 text-accent" data-id="element-245" />
              </div>
            </div>
            <div data-id="element-246">
              <h4 className="text-lg font-semibold text-gray-900" data-id="element-247">
                Official Uniform
              </h4>
              <p className="text-gray-600" data-id="element-248">
                Receive a high-quality student uniform ($50 value) to wear
                during training.
              </p>
            </div>
          </div>

          <div className="flex" data-id="element-249">
            <div className="flex-shrink-0 mr-4" data-id="element-250">
              <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center" data-id="element-251">
                <Award className="w-5 h-5 text-purple-600" data-id="element-252" />
              </div>
            </div>
            <div data-id="element-253">
              <h4 className="text-lg font-semibold text-gray-900" data-id="element-254">
                1 Promotion
              </h4>
              <p className="text-gray-600" data-id="element-255">
                Opportunity to test for your first rank advancement during the
                trial.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gray-50 p-6 rounded-xl" data-id="element-256">
        <h4 className="font-semibold text-gray-900 mb-3" data-id="element-257">Why Start Now?</h4>
        <ul className="space-y-2" data-id="element-258">
          <li className="flex items-center text-sm text-gray-600" data-id="element-259">
            <Check className="w-4 h-4 text-green-500 mr-2" data-id="element-260" />
            No long-term contracts required
          </li>
          <li className="flex items-center text-sm text-gray-600" data-id="element-261">
            <Check className="w-4 h-4 text-green-500 mr-2" data-id="element-262" />
            Beginner-friendly environment
          </li>
          <li className="flex items-center text-sm text-gray-600" data-id="element-263">
            <Check className="w-4 h-4 text-green-500 mr-2" data-id="element-264" />
            Small class sizes for personal attention
          </li>
        </ul>
      </div>
    </div>;
}